import { useEffect, useState } from "react";
import axios from "axios";
import { ACCESS_KEY } from "../config";

function LiveBanList() {
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showUnbanModal, setShowUnbanModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 20;

  useEffect(() => {
    getLiveBannedUsers();
  }, []);

  // 1. Live Ban Users Fetch karne ka function
  const getLiveBannedUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://admin.butterlive.co.in/management/live-ban-users",
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );
      // 🔥 Sirf unhi users ko nikalna jinka enableToLive false (Banned) hai
      const bannedOnly = response.data.data.filter(user => !user.enableToLive);
      setUsers(bannedOnly);
    } catch (error) {
      console.log("Error fetching live banned users:", error);
    } finally {
      setLoading(false);
    }
  };

  // 2. Direct List se hi Unban karne ka function
  const handleLiveUnban = async (user) => {
    try {
      const response = await axios.post(
        "https://admin.butterlive.co.in/management/video-live-unban",
        {
          userId: user.userId,
          duration: user.liveBanDuration || "4 Hours",
        },
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );

      // Unban hone ke baad list ko refresh karein
      getLiveBannedUsers();
    } catch (error) {
      console.log(error);
      alert("Video Unban Failed");
    }
  };

  // 3. Filter aur Pagination Logic
  const filteredUsers = users.filter((user) =>
    (user.name || "").toLowerCase().includes(search.toLowerCase()) ||
    String(user.uniqueId || "").includes(search)
  );

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage) || 1;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Live Ban List</h1>
      </div>

      <div className="top-bar">
        <input
          type="text"
          placeholder="Search Name / User ID"
          className="search-box"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="table-card">
        {loading ? (
          <p style={{ padding: "20px", color: "#9ca3af" }}>Loading live banned users...</p>
        ) : (
          <table width="100%" cellPadding="12" style={{ minWidth: "1400px" }}>
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Photo</th>
                <th>Name</th>
                <th>User ID</th>
                <th>Coins</th>
                <th>Diamonds</th>
                <th>Country</th>
                <th>Level</th>
                <th>Ban Count</th>
                <th>Duration</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {currentUsers.length > 0 ? (
                currentUsers.map((user, index) => (
                  <tr key={user.id || index}>
                    <td>{indexOfFirstUser + index + 1}</td>
                    <td>
                      {user.image ? (
                        <img src={user.image} alt="" className="user-avatar" />
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>{user.name}</td>
                    <td>{user.uniqueId}</td>
                    <td>{user.coins}</td>
                    <td>{user.diamonds}</td>
                    <td>{user.country}</td>
                    <td>{user.level}</td>
                    <td>{user.liveBanCount || 0}</td>
                    <td>{user.liveBanDuration || "-"}</td>
                    <td>
                      <span className="status-banned">Banned</span>
                    </td>
                    <td>
                      <button
                        onClick={() => {
                          setSelectedUser(user);
                          setShowUnbanModal(true);
                        }}
                        className="ban-btn ban-btn-unban"
                      >
                        Unban
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="no-data" style={{ textAlign: "center", padding: "30px", color: "#9ca3af" }}>
                    No currently live banned users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        <div className="pagination">
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
            Previous
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
            Next
          </button>
        </div>
      </div>

      {/* Unban Confirmation Modal */}
      {showUnbanModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Confirm Unban</h3>
            <p>Are you sure you want to unban this user from Live?</p>
            <br />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowUnbanModal(false)} style={{ background: '#374151' }}>
                Cancel
              </button>
              <button
                className="ban-btn ban-btn-unban"
                onClick={() => {
                  handleLiveUnban(selectedUser);
                  setShowUnbanModal(false);
                }}
              >
                Confirm Unban
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LiveBanList;
